module.exports = __webpack_public_path__ + "static/media/ivertical.8a881340.svg";